null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala/scala/v2.12.8/src/library/scala/Function2.scala